import Entity from '../entity'

export default class Advertisement extends Entity<number>{
    title: string  = null;
    advertisementCoverImageUrl: string  = null;
    priority: number  = null;
    tenantId: number  = null;
    isPublished: boolean;
    pageUrl: string  = null;
    position: string  = null;
    beginTime: Date  = null;
    endTime: Date  = null;
    remark: string  = null;
}